// extracted by mini-css-extract-plugin
export default {"page_wrapper":"Team_page_wrapper__R+zmU","section_wrapper":"Team_section_wrapper__R-olS"};